module.exports = __webpack_public_path__ + "img/proType.9a3d751b.png";